export default [
  // 客服-工单评价
  {
    path: '/customerService/evaluation',
    name: 'customerService-evaluation',
    hidden: true,
    component: () => import('@/views/customerService/Evaluation.vue'),
    meta: {
      auth: 0,
    },
  },
];
